import { connect } from "react-redux";
import get from "lodash/get";

import {
  handleConnectLastState as onConnectLastState,
  handleStartConnection as onStartConnection,
  handleAddUserToGroup as onAddUserToGroup,
  handleStopConnect as onStopConnect,
} from "../../actions/signalRActions";

const mapStateToProps = (state) => ({
  dataConnectionStateSR: state.signalR.dataConnectionState,
  dataStartConnectionStateSR: state.signalR.dataStartConnectionState,
  dataUserGroupStateSR: state.signalR.dataUserGroupState,
  connectionSR: get(state, ["signalR", "connection"], null),
  errorSR: get(state, ["signalR", "error"], null),
});

const mapDispatchToProps = {
  onConnectLastState,
  onStartConnection,
  onAddUserToGroup,
  onStopConnect,  
};

const withSignalR = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withSignalR };
